import { useEffect } from 'react'
import { useEditor } from '../store/editor'
import { saveNow } from './persist'

function typing(e: KeyboardEvent): boolean {
  const t = e.target as HTMLElement | null
  if (!t) return false
  const tag = t.tagName
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || t.isContentEditable
}

export function togglePlay() {
  const s = useEditor.getState()
  if (!s.project.clips.length) return
  if (!s.playing && s.playhead >= s.project.durationSec - 0.02) s.setPlayhead(0)
  s.setPlaying(!s.playing)
}

export function stepFrames(n: number) {
  const s = useEditor.getState()
  const fps = s.project.settings.fps || 30
  s.set({ playing: false })
  const f = Math.round(s.playhead * fps) + n
  s.setPlayhead(Math.max(0, Math.min(s.project.durationSec, f / fps)))
}

export function useShortcuts() {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const s = useEditor.getState()
      const mod = e.ctrlKey || e.metaKey
      if (mod && e.key.toLowerCase() === 's') {
        e.preventDefault()
        saveNow()
        return
      }
      if (typing(e) || s.dialog) return
      const k = e.key
      if (k === ' ') { e.preventDefault(); togglePlay() }
      else if (mod && k.toLowerCase() === 'z' && !e.shiftKey) { e.preventDefault(); s.undo() }
      else if (mod && (k.toLowerCase() === 'y' || (k.toLowerCase() === 'z' && e.shiftKey))) { e.preventDefault(); s.redo() }
      else if (mod && k.toLowerCase() === 'd') { e.preventDefault(); s.duplicateSelected() }
      else if (mod && k.toLowerCase() === 'a') { e.preventDefault(); s.select(s.project.clips.map((c) => c.id)) }
      else if (mod && k.toLowerCase() === 'b') { e.preventDefault(); s.splitAtPlayhead() }
      else if (!mod && (k === 's' || k === 'S')) { e.preventDefault(); s.splitAtPlayhead() }
      else if (k === 'Delete' || k === 'Backspace') { e.preventDefault(); s.deleteSelected() }
      else if (k === 'ArrowLeft') { e.preventDefault(); stepFrames(e.shiftKey ? -(s.project.settings.fps || 30) : -1) }
      else if (k === 'ArrowRight') { e.preventDefault(); stepFrames(e.shiftKey ? (s.project.settings.fps || 30) : 1) }
      else if (k === 'Home') { e.preventDefault(); s.set({ playing: false }); s.setPlayhead(0) }
      else if (k === 'End') { e.preventDefault(); s.set({ playing: false }); s.setPlayhead(s.project.durationSec) }
      else if (k === 'Escape') s.select([])
      else if (k === '+' || k === '=') s.setPps(s.pps * 1.25)
      else if (k === '-') s.setPps(s.pps / 1.25)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])
}
